import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Malta: Country = {
    identifier: "Malta",
    name: "Malta",
    countryCode: "MT",
    group: CountryGroup.EUROPE,
    isUNMember: true,
    flag: "🇲🇹",
    svgPath: "m 515.06575,355.0364 -0.168,0.053 -0.167,-0.104 -0.039,-0.063 0.232,-0.053 0.114,0.047 0.048,0.09 -0.02,0.03 z m 0.709,0.604 -0.094,0.112 -0.27,-0.005 -0.236,-0.175 -0.002,-0.366 0.272,0.072 0.249,0.245 0.081,0.117 z",
}
